import { AbstractStruct } from '@pushly/models/lib/structs/abstract-struct'
import { NotificationTemplatePayload } from '../types/notification-payload'
import { Expose, Type } from 'class-transformer'
import { IsArray, IsIn, IsOptional, ValidateNested } from 'class-validator'
import { NotificationSource } from '@pushly/models/lib/enums/notification-source'
import { IsNonNegativeNumericString } from '@pushly/models/lib/class-validators/is-non-negative-numeric-string'
import { IsRecord } from '@pushly/models/lib/class-validators/is-record'
import { NotificationDtoTemplate } from '../../notifications/dtos/notification-dto'
import { DeliveryChannel } from '@pushly/models/lib/enums'
import { getEnumValues } from '@pushly/models'
import { JourneyNotificationTtlConfig } from './journey-notification-ttl-config'

export class CreateJourneyStepRequestNotificationPayload extends AbstractStruct {
    @Expose()
    @IsNonNegativeNumericString()
    @IsOptional()
    public id?: string

    @Expose()
    @IsIn(getEnumValues(DeliveryChannel), { each: true })
    @IsArray()
    public channels: DeliveryChannel[]

    @Expose()
    @IsIn([NotificationSource.CAMPAIGN])
    public source: NotificationSource.CAMPAIGN

    @Expose()
    @IsRecord(String)
    public template: NotificationTemplatePayload | NotificationDtoTemplate

    @Expose()
    @ValidateNested()
    @Type(() => JourneyNotificationTtlConfig)
    public deliverySpec: JourneyNotificationTtlConfig

    @Expose()
    @IsRecord(String)
    public meta: Record<string, any>
}
